// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4e6699f0] .el-input-number--medium {\n  width: 170px !important;\n}\n.from-tips[data-v-4e6699f0] {\n  margin-top: 5px !important;\n  color: #999;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
